import { useEffect, useRef } from 'react';
import { usePicoXTrack } from '@eventbrite/bsp-sdk/react';
import type { WebappResponse } from '@eventbrite/event-listing-service-client';

import { PICO_EVENT_NAMES } from '@/components/_shared/constants';
import { toPrivateEventId } from '@/utils/picoEventId';

export const LISTINGS_PAGE_VIEW_VARIANT = 'old';

type UseListingsPageViewTrackingEffectArgs = {
  pageContext: WebappResponse | null | undefined;
  isPreview: boolean | undefined;
};

export function useListingsPageViewTrackingEffect({ pageContext, isPreview }: UseListingsPageViewTrackingEffectArgs) {
  const trackPicoXEvent = usePicoXTrack();
  const listingsPageViewTrackedEventIdRef = useRef<string | null>(null);

  useEffect(() => {
    const eventId = pageContext?.basicInfo?.id;

    if (isPreview || !eventId) {
      return;
    }

    if (listingsPageViewTrackedEventIdRef.current === eventId) {
      return;
    }

    const ebEventId = toPrivateEventId(eventId);
    if (!ebEventId) {
      return;
    }

    listingsPageViewTrackedEventIdRef.current = eventId;
    trackPicoXEvent(PICO_EVENT_NAMES.LISTINGS_PAGE_VIEW, {
      listings_variant: LISTINGS_PAGE_VIEW_VARIANT,
      eb_event_id: ebEventId,
      path: window.location.pathname + window.location.search,
    });
  }, [pageContext, isPreview, trackPicoXEvent]);
}
